<template>
  <section class="care">
    <div class="center">
      <h3>关怀切入点</h3>
      <div class="content">
        <div>
          <img src="@/assets/image/care1.png"/>
          <p>员工职业周期</p>
        </div>
        <div>
          <img src="@/assets/image/care2.png"/>
          <p>员工关怀</p>
        </div>
        <div>
          <img src="@/assets/image/care3.png"/>
          <p>年度事件周期</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'Care',
  props: {
  }
}
</script>
<style scoped lang="less">
.care {
  height: 943px;
  width: 100%;
  .center {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    color:@text-color;
    text-align: center;
    overflow: hidden;
    h3 {
      font-size:30px;
      font-family: @PingFangSC-Semibold;
      font-weight:600;
      line-height:42px;
      margin-top: 58px;
    }
    .content {
      margin-top: 36px;
      div {
        margin-bottom: 74px;
        img {
          height: 116px;
          width: 1200px;
          margin-bottom: 34px;
        }
        p {
          font-size:22px;
          font-family: @PingFangSC-Semibold;
          font-weight:600;
          color:rgba(111,204,243,1);
          line-height:30px;
        }
      }
      div:nth-child(1) {
        p {
          color:rgba(111,204,243,1);
        }
      }
      div:nth-child(2) {
        p {
          color:rgba(241,174,44,1);
        }
      }
      div:nth-child(3) {
        p {
          color:rgba(255,92,55,1);
        }
      }
    }
  }
}
</style>
